import {
  IDownloadAllInprocessCheck,
  IDownloadCartonQRCodeBank,
  IDownloadExcelRequest,
  IDownloadInprocessCheck,
  IDownloadLocationListConfirmPeriodicCycleCountRequest,
  IDownloadLODeliveryProgressRequest,
  IDownloadLODocumentByIdRequest,
  IDownloadMaterialRequisitionDetailReportRequest,
  IDownloadMaterialRequisitionReportRequest,
  IDownloadProductionPlanDetailRequest,
  IDownloadProductionPlanRequest,
  IDownloadQRCodeBankRequest,
  IDownloadRequestMaterialDetail,
  IDownloadReturnReport,
} from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";
const prefix = PREFIX.export;
const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};

const URL_DOWNLOAD_PRODUCT_MASTER_DATA = getUrl("export-masterdata-product");
const URL_DOWNLOAD_WAREHOUSE_MASTER_DATA = getUrl(
  "export-masterdata-warehouses"
);
const URL_DOWNLOAD_ZONE_MASTER_DATA = getUrl("export-masterdata-zone");

const URL_DOWNLOAD_ZONE_DETAIL_MASTER_DATA = getUrl(
  "export-masterdata-zone-detail"
);
const URL_DOWNLOAD_PALLET_MASTER_DATA = getUrl("export-masterdata-pallet");
const URL_DOWNLOAD_COMPANY_MASTER_DATA = getUrl("export-masterdata-company");
const URL_DOWNLOAD_USER_MASTER_DATA = getUrl("export-masterdata-user");
const URL_DOWNLOAD_PRODUCTION_PLAN = getUrl("get-production-plan-data");
const URL_DOWNLOAD_RECEIVE_DOCUMENT = getUrl("export-stock-receiving-header");
const URL_DOWNLOAD_RECEIVE_DOCUMENT_BY_ID = getUrl("stock-receiving-document");
const URL_DOWNLOAD_RECEIVE_EXPORT_PALLET_LABEL = getUrl(
  "export-pallet-productlot-material"
);
const URL_DOWNLOAD_LO_DOCUMENT = getUrl("export-loading-order-document");
const URL_DOWNLOAD_LO_DOCUMENT_FORM = getUrl("loading-order-import-templates");
const URL_DOWNLOAD_LO_DOCUMENT_BY_ID = getUrl("loading-order-document");
const URL_DOWNLOAD_LO_DELIVERY_PROGRESS = getUrl(
  "loading-order-delivery-progress-document"
);

const URL_DOWNLOAD_AUDIT_TRAIL = getUrl("export-report-audit-trail");
const URL_DOWNLOAD_QR_CODE_TRACKING = getUrl(
  "export-list-management-barcode-tracking-report"
);
const URL_DOWNLOAD_QR_CODE_BANK_XLSX = getUrl("export-qrcode-from-bank");
const URL_DOWNLOAD_QR_CODE_BANK_CSV = getUrl("export-qrcode-from-bank-csv");
const URL_DOWNLOAD_WAREHOUSE_REPORT = getUrl("location-report");
const URL_DOWNLOAD_PACKING_REPORT = getUrl("packaging-log-report");
const URL_DOWNLOAD_FORKLIFT_PERFORMANCE_REPORT = getUrl(
  "export-report-forklift-performance"
);
const URL_DOWNLOAD_DELIVERY_HISTORY_REPORT = getUrl(
  "delivery-barcode-history-report"
);
const URL_DOWNLOAD_DELIVERY_HISTORY_FOR_MARKETING_REPORT =
  getUrl("get-marketing-data");
const URL_DOWNLOAD_INVENTORY_COMPARISON_REPORT = getUrl("bay4s");
const URL_DOWNLOAD_PRODUCTION_PLAN_DETAIL = getUrl("get-production-plan-info");

const URL_DOWNLOAD_PRODUCTION_PLAN_FORM = getUrl(
  "production-plan-import-templates"
);
const URL_DOWNLOAD_RECEIVE_FORM = getUrl("receiving-import-templates");
const URL_DOWNLOAD_INVENTORY_COMPARISON_FORM = getUrl("bay4s-import-templates");
const URL_DOWNLOAD_MATERIAL_REQUISITION_FORM = getUrl(
  "request-material-import-templates"
);
const URL_DOWNLOAD_MATERIAL_MOVEMENT_FORM = getUrl(
  "material-movement-import-templates"
);
const URL_DOWNLOAD_PACKAGING_MOVEMENT_FORM = getUrl(
  "packaging-movement-import-templates"
);
const URL_DOWNLOAD_PERIODIC_CYCLE_COUNT_LOCATION_FORM = getUrl(
  "cycle-count-location-import-templates"
);
const URL_DOWNLOAD_PERIODIC_CYCLE_COUNT_PRODUCT_FORM = getUrl(
  "cycle-count-product-import-templates"
);

const URL_DOWNLOAD_GET_LOCATION_PERIODIC_CYCLE_COUNT =
  getUrl("get-cycle-count");
const URL_DOWNLOAD_GET_LOCATION_CONFIRM_PERIODIC_CYCLE_COUNT = getUrl(
  "get-cycle-count-confirm"
);

const URL_DOWNLOAD_RETURN_REPORT = getUrl("export-return-product");
const URL_DOWNLOAD_MATERIAL_REQUISITION = getUrl(
  "export-list-management-stock-movement"
);
const URL_DOWNLOAD_MATERIAL_REQUISITION_DETAIL = getUrl(
  "export-request-material-detail"
);

const URL_DOWNLOAD_CARTON_QR_CODE_BANK = getUrl("export-carton-code-from-bank");
const URL_DOWNLOAD_CYCLE_COUNT_QA_COLLECT = getUrl(
  "export-cycle-count-qr-collect"
);
const URL_DOWNLOAD_EN_USERGUIDE = getUrl("export-user-guide-eng");
const URL_DOWNLOAD_VN_USERGUIDE = getUrl("export-user-guide-vn");
const URL_DOWNLOAD_REQUEST_MATERIAL_DETAIL = getUrl(
  "export-request-material-detail"
);

const URL_DOWNLOAD_STOCK_MOVEMENT = getUrl("export-stock-movement");
const URL_DOWNLOAD_INPROCESS_CHECK = getUrl("export-in-process-check");
const URL_DOWNLOAD_ALL_INPROCESS_CHECK = getUrl("export-all-in-process-checks");

class DownloadApiService extends BaseApiService {
  public downloadENUserGuide = (params: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_EN_USERGUIDE, { params });
  public downloadVNUserGuide = (params: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_VN_USERGUIDE, { params });
  public downloadProductMasterData = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_PRODUCT_MASTER_DATA, {
      params: request,
    });
  public downloadWarehouseMasterData = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_WAREHOUSE_MASTER_DATA, {
      params: request,
    });
  public downloadZoneMasterData = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_ZONE_MASTER_DATA, {
      params: request,
    });
  public downloadZoneDetailMasterData = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_ZONE_DETAIL_MASTER_DATA, {
      params: request,
    });
  public downloadPalletMasterData = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_PALLET_MASTER_DATA, {
      params: request,
    });
  public downloadCompanyMasterData = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_COMPANY_MASTER_DATA, {
      params: request,
    });
  public downloadUserMasterData = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_USER_MASTER_DATA, {
      params: request,
    });
  public downloadProductionPlan = (request: IDownloadProductionPlanRequest) =>
    this.download(URL_DOWNLOAD_PRODUCTION_PLAN, {
      params: request,
    });
  public downloadProductionPlanDetail = (
    request: IDownloadProductionPlanDetailRequest
  ) =>
    this.download(URL_DOWNLOAD_PRODUCTION_PLAN_DETAIL, {
      params: request,
    });
  public downloadProductionPlanForm = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_PRODUCTION_PLAN_FORM, {
      params: request,
    });
  public downloadReceiveDocument = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_RECEIVE_DOCUMENT, {
      params: request,
    });
  public downloadReceiveDocumentById = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_RECEIVE_DOCUMENT_BY_ID, {
      params: request,
    });
  public downloadReceiveExportPalletLabel = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_RECEIVE_EXPORT_PALLET_LABEL, {
      params: request,
    });
  public downloadReceiveForm = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_RECEIVE_FORM, {
      params: request,
    });
  public downloadLODocument = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_LO_DOCUMENT, {
      params: request,
    });
  public downloadLODocumentForm = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_LO_DOCUMENT_FORM, {
      params: request,
    });
  public downloadLODocumentById = (request: IDownloadLODocumentByIdRequest) =>
    this.download(URL_DOWNLOAD_LO_DOCUMENT_BY_ID, {
      params: request,
    });
  public downloadLODeliveryProgress = (
    request: IDownloadLODeliveryProgressRequest
  ) =>
    this.download(URL_DOWNLOAD_LO_DELIVERY_PROGRESS, {
      params: request,
    });
  public downloadAuditTrail = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_AUDIT_TRAIL, {
      params: request,
    });
  public downloadQRCodeTracking = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_QR_CODE_TRACKING, {
      params: request,
    });
  public downloadQRCodeBankXlsx = (request: IDownloadQRCodeBankRequest) =>
    this.get(URL_DOWNLOAD_QR_CODE_BANK_XLSX, {
      params: request,
    });
  public downloadQRCodeBankCsv = (request: IDownloadQRCodeBankRequest) =>
    this.get(URL_DOWNLOAD_QR_CODE_BANK_CSV, {
      params: request,
    });
  public downloadWarehouseReport = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_WAREHOUSE_REPORT, {
      params: request,
    });
  public downloadPackingReport = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_PACKING_REPORT, {
      params: request,
    });
  public downloadForkliftPerformanceReport = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_FORKLIFT_PERFORMANCE_REPORT, {
      params: request,
    });
  public downloadDeliveryHistoryReport = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_DELIVERY_HISTORY_REPORT, {
      params: request,
    });
  public downloadDeliveryHistoryForMarketingReport = (
    request: IDownloadExcelRequest
  ) =>
    this.download(URL_DOWNLOAD_DELIVERY_HISTORY_FOR_MARKETING_REPORT, {
      params: request,
    });
  public downloadInventoryComparisonForm = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_INVENTORY_COMPARISON_FORM, {
      params: request,
    });
  public downloadInventoryComparisonReport = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_INVENTORY_COMPARISON_REPORT, {
      params: request,
    });
  public downloadMaterialRequisitionForm = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_MATERIAL_REQUISITION_FORM, {
      params: request,
    });
  public downloadMaterialMovementForm = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_MATERIAL_MOVEMENT_FORM, {
      params: request,
    });
  public downloadPackagingMovementForm = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_PACKAGING_MOVEMENT_FORM, {
      params: request,
    });
  public downloadPeriodicCycleCountProductForm = (
    request: IDownloadExcelRequest
  ) =>
    this.download(URL_DOWNLOAD_PERIODIC_CYCLE_COUNT_PRODUCT_FORM, {
      params: request,
    });
  public downloadPeriodicCycleCountLocationForm = (
    request: IDownloadExcelRequest
  ) =>
    this.download(URL_DOWNLOAD_PERIODIC_CYCLE_COUNT_LOCATION_FORM, {
      params: request,
    });

  public downloadLocationListConfirmPeriodicCycleCount = (
    request: IDownloadLocationListConfirmPeriodicCycleCountRequest
  ) =>
    this.download(URL_DOWNLOAD_GET_LOCATION_CONFIRM_PERIODIC_CYCLE_COUNT, {
      params: request,
    });
  public downloadLocationListPeriodicCycleCount = (
    request: IDownloadLocationListConfirmPeriodicCycleCountRequest
  ) =>
    this.download(URL_DOWNLOAD_GET_LOCATION_PERIODIC_CYCLE_COUNT, {
      params: request,
    });

  public downloadReturnReport = (request: IDownloadReturnReport) =>
    this.download(URL_DOWNLOAD_RETURN_REPORT, {
      params: request,
    });

  public downloadMaterialRequisitionReportRequest = (
    request: IDownloadMaterialRequisitionReportRequest
  ) =>
    this.download(URL_DOWNLOAD_MATERIAL_REQUISITION, {
      params: request,
    });

  public downloadMaterialRequisitionDetailReportRequest = (
    request: IDownloadMaterialRequisitionDetailReportRequest
  ) =>
    this.download(URL_DOWNLOAD_MATERIAL_REQUISITION_DETAIL, {
      params: request,
    });
  public downloadCartonQRCodeBank = (request: IDownloadCartonQRCodeBank) =>
    this.get(URL_DOWNLOAD_CARTON_QR_CODE_BANK, {
      params: request,
    });

  public downloadRequestMaterialDetail = (
    request: IDownloadRequestMaterialDetail
  ) =>
    this.download(URL_DOWNLOAD_REQUEST_MATERIAL_DETAIL, {
      params: request,
    });
  public downloadCycleCountQACollect = (request: IDownloadExcelRequest) =>
    this.download(URL_DOWNLOAD_CYCLE_COUNT_QA_COLLECT, {
      params: request,
    });
  public downloadStockMovement = (request: IDownloadRequestMaterialDetail) =>
    this.download(URL_DOWNLOAD_STOCK_MOVEMENT, {
      params: request,
    });

  public downloadInprocessCheck = (request: IDownloadInprocessCheck) =>
    this.download(URL_DOWNLOAD_INPROCESS_CHECK, {
      params: request,
    });
  public downloadAllInprocessCheck = (request: IDownloadAllInprocessCheck) =>
    this.download(URL_DOWNLOAD_ALL_INPROCESS_CHECK, {
      params: { ...request, fileFormat: "zip" },
    });
}

export default new DownloadApiService();
